export enum AccountStatusEnum {
  STATUS1 = 1,
  STATUS2 = 2,
  STATUS3 = 3,
  STATUS4 = 4,
  STATUS5 = 5,
  STATUS6 = 6,
}
